import React from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import ContextualLink from '@magoosh/gre/app/contextual_link';
import { paths } from 'config/path_helpers';
import NotesIllustration from '../../assets/notes_illustration.svg';
import { PageCard } from '../../lib/page_card';
import { Wrapper } from '../../lib/wrapper';
import Icon from '@magoosh/gre/assets/icons';
import { HeaderWithIllustration } from '../../lib/header_with_illustration';
import ExamSectionNotes from './exam_section_notes';
import {  TabButton } from '@magoosh/lib/button';

const Notes: React.FC = () => {
  const { sectionName } = useParams();

  return (
    <Wrapper>
      <Helmet>
        <title>Notes - Magoosh GRE</title>
      </Helmet>

      <div className="u-margin-V-m">
        <ContextualLink href={paths.dashboard()}>
          <strong>Home</strong>
        </ContextualLink>{' '}
        {'>'} <span>Notes</span>
      </div>
      <PageCard>
        <HeaderWithIllustration
          illustration={NotesIllustration}
          illustrationAltText="Students leaping with excitement in front of a note"
          icon={<Icon iconType={'Notes'} fill={'#007BE8'} />}>
          <h2>Notes</h2>
          <p>
            Use notes to help you remember key concepts or strategies. You may take notes on any lesson video
            or answer explanation.
          </p>
        </HeaderWithIllustration>

        <hr className="u-margin-B-xs" />
        <div className="text-center">
          <ContextualLink href={paths.examSectionNotes('math')}>
            <TabButton disabled={sectionName === 'math'}>Math</TabButton>
          </ContextualLink>
          <ContextualLink href={paths.examSectionNotes('verbal')}>
            <TabButton disabled={sectionName === 'verbal'}>Verbal</TabButton>
          </ContextualLink>
          <ContextualLink href={paths.examSectionNotes('writing')}>
            <TabButton disabled={sectionName === 'writing'}>Writing</TabButton>
          </ContextualLink>
        </div>

        <hr className="u-margin-T-xs" />

        <ExamSectionNotes sectionName={sectionName} />
      </PageCard>
    </Wrapper>
  );
};

export default Notes;
